export enum TagListDialogCloseAction {
  SAVE = 'Zapisz',
  CLOSE = 'Zamknij',
}
